require('./contractsAccountInterveners.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { formatText, FormattedText, hasTranslation } = require('core/i18n').i18n;
// @ components
const BrokerIntervenerItem = require('components/broker/brokerIntervener/brokerIntervenerItem/brokerIntervenerItem');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ constants
const { ACCOUNT_INTERVENTION_OWNER_CODE } = require('constants/index');
const {ACCOUNT_INTERVINENTS} = require('constants/flagBasedFeatures');
const {INTERVENER_CODES} = require('constants/interveners');

class ContractsAccountInterveners extends React.Component {
    constructor(props) {
        super(props);
        this.handleIntervenerTypeChange = this.handleIntervenerTypeChange.bind(this);
        this.buildIntervenerItems = this.buildIntervenerItems.bind(this);
        this.handleIntervenerRemove = this.handleIntervenerRemove.bind(this);
        this.handleIntervenerAdd = this.handleIntervenerAdd.bind(this);
        this.handleRestoreDefaultInterveners = this.handleRestoreDefaultInterveners.bind(this);
        this.buildIntervenerLinkActions = this.buildIntervenerLinkActions.bind(this);
    }

    buildIntervenerItems() {
        const {
            immContract,
            showIntervenerControls,
            hideIntervenerLinkActions,
            intervenerOptions,
            hierarchicalTypeSelection,
            intervenersSubHeader,
            header,
            restoreDefaultEnabled,
            flagBasedFeatures,
            customCategoryEvent
        } = this.props;
        const currentInterveners = immContract.get('interveners');
        const onlyOneOwnerLeft = currentInterveners.filter(intervener => intervener.get('typeNumber') === ACCOUNT_INTERVENTION_OWNER_CODE).size < 2;
        const availableInterveners = immContract.get('availableInterveners');
        const intervenersLinks = !hideIntervenerLinkActions ? this.buildIntervenerLinkActions() : null;
        const restoreDefaultLink = restoreDefaultEnabled && immContract.get('intervenersModified') ? this.buildRestoreDefaultIntervenersLink() : null;
        const removeIconChildren = (<FormattedText value="contractsView-exclude" />);
        const isNotAllowedInterventsByOriginCountry = !flagBasedFeatures.get(ACCOUNT_INTERVINENTS);

        let headerTag = header;
        let headerSubtitle = intervenersSubHeader
            ? (<FormattedText value={intervenersSubHeader} className="contracts-account-interveners__sub-header"/>)
            : null;
        let isOnlyOwnerGlobal = false;
        let showRemoveIconGlobal = showIntervenerControls;

        if (currentInterveners.size === 1 || isNotAllowedInterventsByOriginCountry) {
            showRemoveIconGlobal = false;
            isOnlyOwnerGlobal = true;
            headerSubtitle = null;
            headerTag = 'broker-stockContractStep2Interveners';
        }

        const buildOnlyGlobalIntervener = () => {
            const index = Object.values(INTERVENER_CODES).findIndex(n => n === currentInterveners.getIn([0, 'typeNumber'], '01'));
            let intervener = Object.keys(INTERVENER_CODES)[index > -1 ? index : 0];
            let tag = hasTranslation(`brokerIntevenerItem-${intervener}`) ? intervener : 'holder';

            return (
                <div className="contracts-account-interveners__select__only-readable">
                    <header>
                        <span>{<FormattedText value="broker-stockIntervenerItemNameLabel"/>}</span>
                        <span>{<FormattedText value="hireDerivativesAccount-interventionType"/>}</span>
                    </header>
                    <section>
                        <span>{currentInterveners.getIn([0, 'name'], '-')}</span>
                        <span>{formatText(`brokerIntevenerItem-${tag}`)}</span>
                    </section>
                </div>
            );
        };

        const intervenersList = isOnlyOwnerGlobal
            ? buildOnlyGlobalIntervener()
            : currentInterveners.map((intervener, index) => {
            const interveners = availableInterveners.push(intervener);
            const lastOwnerAvailable = onlyOneOwnerLeft && intervener.get('typeNumber') === ACCOUNT_INTERVENTION_OWNER_CODE;
            let showRemoveIcon = showRemoveIconGlobal;
            let disableTypeChange = isOnlyOwnerGlobal;

            if (intervener.get('currentIntervener')) {
                showRemoveIcon = false;
            } else if (!lastOwnerAvailable){
                showRemoveIcon = true;
            }

            if (lastOwnerAvailable) {
                disableTypeChange = true;
            }

            return (
                <BrokerIntervenerItem
                    key={index}
                    index={index}
                    originalInterveners={interveners}
                    intervenerName={intervener.get('name')}
                    intervenerType={intervener.get('typeNumber')}
                    intervenerOriginalTypeNumber={intervener.get('originalTypeNumber')}
                    onIntervenerTypeChange={this.handleIntervenerTypeChange}
                    onIntervenerRemove={this.handleIntervenerRemove}
                    showRemoveIcon={showRemoveIcon}
                    isOnlyIntervener={true}
                    isOnlyOwner={disableTypeChange}
                    removeIconChildren={removeIconChildren}
                    intervenerOptions={intervenerOptions}
                    hierarchicalTypeSelection={hierarchicalTypeSelection}
                    useIntervenerCode={true}
                    customCategoryEvent={customCategoryEvent}
                />
            );
        });
        return (
            <div className="contracts-account-interveners__interveners-container">
                <FormattedText value={headerTag} className="contracts-account-interveners__header" />
                {headerSubtitle}
                <div className="contracts-account-interveners__select">
                    {intervenersList}
                    {intervenersLinks || restoreDefaultLink}
                </div>
            </div>
        )
    }

    buildIntervenerLinkActions() {
        const { immAccounts, immContract, accountNumber } = this.props;
        const addIntervenerLabel = formatText('broker-stockIntervenerAddIntervenerLabel');
        const currentInterveners = immContract.get('interveners');
        let originalInterveners = immAccounts.getIn(['byId', accountNumber, 'interveners', 'list']);
        originalInterveners = originalInterveners.size > 0 ? originalInterveners : immContract.get('intervenersOriginal');
        // The logic for the following if is not correct because it only compares the size of the lists so,
        // if you only changed a role the buttons don't show
        if (currentInterveners && originalInterveners && currentInterveners.size !== originalInterveners.size) {
            return (
                <div>
                    <a className="contracts-account-interveners__action-links" onClick={this.handleIntervenerAdd}>
                        {addIntervenerLabel}
                    </a>
                    <span className="contracts-account-interveners__action-links"> | </span>
                    {this.buildRestoreDefaultIntervenersLink()}
                </div>
            );
        }
    }

    buildRestoreDefaultIntervenersLink(){
        const restoreValuesLabel = formatText('broker-stockIntervenerRestoreValuesLabel');
        return (
            <OKButton modifier="ghost" onClick={this.handleRestoreDefaultInterveners}>
                {restoreValuesLabel}
            </OKButton>
        );
    }

    handleIntervenerAdd(e) {
        e.preventDefault();
        this.props.addIntervener();
    }

    handleIntervenerRemove(index) {
        const { immAccounts , accountNumber, removeIntervener } = this.props;
        const originalInterveners = immAccounts.getIn(['byId', accountNumber, 'interveners', 'list']);
        removeIntervener(index, originalInterveners);
    }

    handleIntervenerTypeChange(index, type) {
        this.props.setIntervenerType(index, type, true);
    }

    handleRestoreDefaultInterveners(e) {
        e.preventDefault();
        const { immAccounts, accountNumber, restoreDefaultInterveners, immContract } = this.props;
        let originalInterveners = immAccounts.getIn(['byId', accountNumber, 'interveners', 'list']);
        originalInterveners = originalInterveners.size > 0 ? originalInterveners : immContract.get('intervenersOriginal');
        restoreDefaultInterveners(originalInterveners);
    }

    render() {
        const { immContract } = this.props;
        const currentInterveners = immContract.get('interveners');
        let content = null;

        if (currentInterveners.size) {
            content = this.buildIntervenerItems();
        }

        return content;
    }
}

ContractsAccountInterveners.defaultProps = {
    showIntervenerControls: false,
    header: 'contractsView-intervenersSelectionHeader',
    hideIntervenerLinkActions: true,
    customCategoryEvent: null
};

ContractsAccountInterveners.propTypes = {
    accountNumber: PropTypes.string.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContract: PropTypes.object.isRequired,
    showIntervenerControls: PropTypes.bool,
    setIntervenerType: PropTypes.func.isRequired,
    addIntervener: PropTypes.func.isRequired,
    removeIntervener: PropTypes.func.isRequired,
    restoreDefaultInterveners: PropTypes.func.isRequired,
    hideIntervenerLinkActions: PropTypes.bool,
    intervenerOptions: PropTypes.array,
    hierarchicalTypeSelection:  PropTypes.bool,
    intervenersSubHeader: PropTypes.string,
    header: PropTypes.string,
    restoreDefaultEnabled: PropTypes.bool,
    flagBasedFeatures: PropTypes.object,
    customCategoryEvent: PropTypes.string
};

module.exports = ContractsAccountInterveners;
